import { Fragment } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { InfoBlock } from '../../../components/common';
import { EColorStatus } from '../../../modules/app/appConstants';
import { makeSelectTranslationWizardProductOfferings } from '../../../modules/internationalization/intSelectors';
import { IWizardProductOfferingsTranslation } from '../../../modules/internationalization/types';
import { makeSelectWizardStepName } from '../../../modules/wizard/wizardSelectors';
import { IRootReducer } from '../../../reducers/rootReducer';
import { stringFormatParams } from '../../../utils/stringFormat';
import { IAuthRegion } from '../../PageAuth/types/authTypes';
import { EWizardProductOfferingsSteps } from '../wizardProductOfferingsConstants';
import { makeSelectProductOfferingsRegion } from '../wizardProductOfferingsSelectors';
import { ProductSelectSubscribersRegionNoticeStyled } from './styled/StepSelectSubscribersStyled';

const ProductOfferingsHeader = (props: IConnectedProps) => {

    const { region, translationProductOfferings, wizardStepName } = props;

    const stepTranslation = translationProductOfferings[EWizardProductOfferingsSteps.StepSelectSubscribers];

    return (
        <Fragment>
            {
                wizardStepName === EWizardProductOfferingsSteps.StepSelectSubscribers && !!region &&
                <ProductSelectSubscribersRegionNoticeStyled>
                    <InfoBlock className="info-block" colorStatus={EColorStatus.SUCCESS}>
                        <div dangerouslySetInnerHTML={{
                            __html: stringFormatParams(stepTranslation.regionNoticeHtml, { region: region.name }),
                        }} />
                    </InfoBlock>
                </ProductSelectSubscribersRegionNoticeStyled>
            }
        </Fragment>
    );
};

interface IConnectedProps {
    region?: IAuthRegion;
    translationProductOfferings: IWizardProductOfferingsTranslation;
    wizardStepName: string;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    region: makeSelectProductOfferingsRegion(),
    translationProductOfferings: makeSelectTranslationWizardProductOfferings(),
    wizardStepName: makeSelectWizardStepName(),
})

export default connect(mapStateToProps)(ProductOfferingsHeader);
